import { useEffect, useState } from "react";

import { SortDropdownValue } from "@/modules/common/components";
import { useFilters } from "@/modules/common/filters";
import { usePagination } from "@/modules/common/hooks/usePagination";
import { AdminManagementCompanyManagerUserSortField } from "@/modules/common/types/ManagerUsers.enum";
import { ListAdminManagementCompaniesManagerUsersDto } from "@/service/dto/admin-management-companies";

import { MANAGER_USER_FILTER_FIELDS } from "../../../../constants/ManagerUserFilterFields";
import useManagerUsersList from "../../../../hooks/useManagerUsersList";

import ManagerUsersTabFilterBar from "./ManagerUsersTabFilterBar";
import ManagerUsersTabList from "./ManagerUsersTabList";

interface ManagerUsersTabProps {
  managementCompanyId: string;
}

const ManagerUsersTab = ({ managementCompanyId }: ManagerUsersTabProps) => {
  const [sort, setSort] = useState<SortDropdownValue<AdminManagementCompanyManagerUserSortField> | null>(null);

  const filters = useFilters<ListAdminManagementCompaniesManagerUsersDto>({
    fields: MANAGER_USER_FILTER_FIELDS,
  });

  const { page, setPage, limit, setPageSize } = usePagination();

  const filtersKey = JSON.stringify(filters.queryParams);
  const sortKey = sort ? `${sort.field}:${sort.order}` : "";
  useEffect(() => {
    setPage(1);
  }, [filtersKey, sortKey]);

  const {
    data: users,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useManagerUsersList(managementCompanyId, {
    ...filters.queryParams,
    sortBy: sort?.field,
    sortOrder: sort?.order,
    page,
    limit,
  });

  return (
    <div className="flex flex-col gap-4">
      <ManagerUsersTabFilterBar filters={filters} sort={sort} onSortChange={setSort} />

      <ManagerUsersTabList
        managementCompanyId={managementCompanyId}
        data={users}
        isLoading={isUsersLoading}
        isFetching={isUsersFetching}
        limit={limit}
        onChangePage={setPage}
        onChangePageSize={setPageSize}
      />
    </div>
  );
};

export default ManagerUsersTab;
